<template>
    <Layout navActive='train'>
        <div slot="main" class="home-bg">
            <div class="banner-container">
                <img :src="parentNavigate.navigateWebImg" alt="">
                <!-- <strong>{{isCn ? parentNavigate.navigateCnName : parentNavigate.navigateEnName}}</strong> -->
            </div>
            <div ref="subNav" class="subnav-area" v-if="subNavList.length > 0">
                <span :class="['subnav-item', activeIndex===index?'active':'']"
                    v-for="(subnav, index) in subNavList"
                    :key="index"
                    @click="changeNav(index)"
                >
                    <strong class="block-title">{{isCn?subnav.navigateCnName:subnav.navigateEnName}}</strong>
                    <i class="block-title-line"></i>
                </span>
            </div>
            <div v-show="activeIndex===index" class="content-block" v-for="(subnav, index) in subNavList" :key="index">
                <Safe v-if="subnav.documentUrl === 'trainSafe'" :pageId="subnav.documentId"></Safe>
                <CustomDetail
                    v-if="subnav.documentUrl === 'customSubNav' && subnav.documentType === 1"
                    :pageId="subnav.documentId"
                ></CustomDetail>
                <CustomList
                    v-if="subnav.documentUrl === 'customSubNav' && subnav.documentType === 0"
                    :pageId="subnav.documentId"
                ></CustomList>
            </div>
        </div>
    </layout>
</template>

<script>
import ajax from '@/utils/ajax';
import getLang from '@/utils/main/language';
import Layout from '@/views/Layout.vue';
import Safe from '@/views/train/Safe.vue';
import CustomDetail from '@/views/detail/CustomDetailBlock.vue';
import CustomList from '@/views/detail/CustomListBlock.vue';

export default {
    name: 'trainSafe',
    components: {
        Layout,
        Safe,
        CustomDetail,
        CustomList,
    },
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            lang: getLang(),
            subNavList: [],
            activeIndex: 0,
            parentNavigate: {},
        };
    },
    watch: {
        $route() {
            this.renderNav();
        },
    },
    mounted() {
        this.renderNav();
    },
    methods: {
        renderNav() {
            const { id } = this.$route.params;
            this.activeIndex = +this.$route.hash.replace('#', '') || 0;
            ajax.get('/web/common/navigate_list.json', { id }).then((result) => {
                this.subNavList = result.data.sonNavigateList;
                this.parentNavigate = result.data.parentNavigate;
            }).catch(() => {});
        },
        changeNav(index) {
            this.activeIndex = index;
            this.$router.replace(`#${index}`);
        },
    },
};
</script>
<style lang="less" scoped>
    .banner-container {
        width: 100%;
        height: 400px;
        position: relative;
        img{
            width: 100%;
            height: 100%;
        }
        strong{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            font-size: 32px;
            color: #fff;
            font-weight: 600;
        }
    }
    .subnav-area {
        text-align: center;
        height: 64px;
        background: #fff;
        width: 100%;
        overflow: hidden;
        .subnav-item {
            display: inline-block;
            color: #9B9B9B;
            margin: 0 24px;
            cursor: pointer;
            .block-title {
                display: block;
                padding-top: 16px;
                font-size: 16px;
                font-weight: 500;
                text-align: center;
                white-space: nowrap;
            }
            .block-title-line {
                display: none;
                margin-top: 8px;
                margin: 0 auto;
                width: 44px;
                height: 4px;
                background: #C71F4B;
            }
            &.active .block-title {
                color: #4A4A4A;
                font-weight: 600;
                font-size: 18px;
            }
            &.active .block-title-line {
                display: block;
            }
        }
    }
</style>
